// PREORDER MIXED CART WARNING – PERSISTENT MESSAGE, POPUP ONLY ON ADD TO CART
document.addEventListener('DOMContentLoaded', function() {
  function handleMixedCart(cartData, options) {
    options = options || {};

    if (!cartData || !cartData.items) return;

    var hasPreorder = false;
    var hasRegular = false;

    cartData.items.forEach(function(item) {
  if (
    item.properties &&
    (item.properties['_preorder_flag'] || item.properties['Pre-order'])
  ) {
    hasPreorder = true;
  } else {
    hasRegular = true;
  }
});


    // Only show anything if BOTH types are present
    if (!(hasPreorder && hasRegular)) return;

    // 1. Cart drawer message – insert ABOVE checkout buttons
    // 1. Mixed cart message – drawer AND cart page

// Drawer (cart drawer)
var ctaAreaDrawer =
  document.querySelector('.drawer--cart .cart__buttons-all') ||
  document.querySelector('.drawer--cart [data-cart-checkout-buttons]');

if (ctaAreaDrawer) {
  var drawerMsg = ctaAreaDrawer.parentNode.querySelector('.preorder-mixed-message--drawer');

  if (!drawerMsg) {
    drawerMsg = document.createElement('div');
    drawerMsg.className = 'preorder-mixed-message preorder-mixed-message--drawer body-small';
    drawerMsg.style.padding = '12px 0';
    drawerMsg.style.textAlign = 'left';
    ctaAreaDrawer.parentNode.insertBefore(drawerMsg, ctaAreaDrawer);
  }

  drawerMsg.innerHTML =
    'Your order contains Pre-Order items and will be dispatched when all items are ready. Please note our dates are subject to change as conditions may mean that our plants are not quite ready for you.';
}

// Cart page
var cartPageHolder = document.querySelector('.cart__mixed-message-holder');

if (cartPageHolder) {
  var pageMsg = cartPageHolder.querySelector('.preorder-mixed-message--page');

  if (!pageMsg) {
    pageMsg = document.createElement('div');
    pageMsg.className = 'preorder-mixed-message preorder-mixed-message--page body-small';
    pageMsg.style.padding = '12px 0';
    pageMsg.style.textAlign = 'left';
    cartPageHolder.appendChild(pageMsg);
  }

  pageMsg.innerHTML =
    'Your order contains Pre-Order items and will be dispatched when all items are ready. Please note our dates are subject to change as conditions may mean that our plants are not quite ready for you.';
}


    // 2. Popup modal – ONLY when explicitly requested
    if (options.showPopup) {
      var modal = document.getElementById('preorderModal');
      if (modal) {
        modal.removeAttribute('hidden');
        modal.style.display = 'flex';
      }

      var closeBtn = modal && modal.querySelector('.preorder-modal__close');
      if (closeBtn) {
        closeBtn.addEventListener(
          'click',
          function() {
            modal.setAttribute('hidden', 'hidden');
            modal.style.display = 'none';
          },
          { once: true }
        );
      }
    }
  }

  function checkCart(showPopup) {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cartData) {
        handleMixedCart(cartData, { showPopup: !!showPopup });
      })
      .catch(function() {});
  }

  // A) On page load: ensure message is there for existing mixed carts (NO popup)
  checkCart(false);

  // B) After add-to-cart: re-check cart + show popup
  document.body.addEventListener('click', function(evt) {
    var addBtn = evt.target.closest('[data-add-to-cart]');
    if (addBtn) {
      setTimeout(function() {
        checkCart(true);
      }, 700);
      return;
    }

    // C) When opening cart drawer: re-check cart so message comes back if drawer HTML was re-rendered
    var cartToggle = evt.target.closest(
      '[data-cart-drawer-toggle], [data-cart-toggle], [data-drawer-toggle="cart"], [data-drawer-toggle="drawer-cart"], a[href="/cart"]'
    );

    if (cartToggle) {
      setTimeout(function() {
        checkCart(false);
      }, 400);
    }
  });
});


document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-notify-me="true"]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const form = btn.closest('product-form');
  if (!form) return;

  const notifyForm = form.querySelector('.notify-form');
  if (!notifyForm) return;

  notifyForm.style.display = notifyForm.style.display === 'none' ? 'block' : 'block';
});


document.addEventListener("click", function (e) {
  const btn = e.target.closest("[data-notify-me='true']");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const section = btn.closest("section, .product");
  if (!section) return;

  const notifyForm = section.querySelector(".notify-form");
  if (!notifyForm) return;

  notifyForm.style.display = "block";
});

document.addEventListener("submit", function (e) {
  const form = e.target.closest(".notify-form");
  if (!form) return;

  e.preventDefault();

  const emailInput = form.querySelector("input[type='email']");
  const email = emailInput?.value.trim();
  if (!email) return alert("Please enter a valid email");

  const productId = form.closest("section, .product").querySelector("[data-notify-me]")
    ?.getAttribute("data-product-id");

  const variantId = form.closest("section, .product").querySelector("[data-notify-me]")
    ?.getAttribute("data-variant-id");

  if (!productId || !variantId) {
    console.error("Missing product/variant ID for Klaviyo");
    return;
  }

  // PAYLOADS
  const bisPayload = {
    data: {
      type: "back-in-stock-subscription",
      attributes: {
        profile: {
          data: {
            type: "profile",
            attributes: { email: email }
          }
        },
        channels: ["email"],
        variant: variantId.toString(),
        product: productId.toString()
      }
    }
  };

  // SEND TO KLAVIYO
  fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=R5g6tm`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      revision: "2025-01-15"
    },
    body: JSON.stringify(bisPayload)
  })
  .then(res => res.json())
  .then(() => {
    form.innerHTML = `<p class="success" style="padding-top:12px;">You're on the list. We'll email you when this is back in stock.</p>`;
  })
  .catch(err => {
    console.error(err);
    alert("Something went wrong, please try again");
  });
});
